import React, { useEffect, useState } from "react";
import Footer from "../component/Footer";
import Header2 from "../component/Header2";
import axios from "axios";
import { toast } from "react-toastify";
import { redirect } from "react-router-dom";
import { Helmet } from "react-helmet";

function Contact() {

  const [name, setname] = useState('');
  const [email, setemail] = useState('');
  const [mobile, setmobile] = useState('');
  const [comment, setcomment] = useState('');

  function validation() {
    var ans = true;
    if (name == "") {
      toast.error(" Name Field is required");
      ans = false;
      return false;
    }
    if (email == "") {
      toast.error(" email Field is required");
      ans = false;
      return false;
    }
    if (mobile == "") {
      toast.error("Mobile Field is required");
      ans = false;
      return false;
    }
    if (comment == "") {
      toast.error("Comment Field is required");
      ans = false;
      return false;
    }
    return ans;
  }

  const submithandle = async (i) => {
    i.preventDefault();
    if (validation()) {

      const formData = new FormData();
      formData.append('id', new Date().getTime().toString());
      formData.append('name', name);
      formData.append('email', email);
      formData.append('mobile', mobile);
      formData.append('comment', comment);

      const res = await axios.post(`https://www.rajvicosmeticclinic.com/RajviApi/contacts_post`, formData);
      console.log(res);

      if (res.status == 200) {
        toast.success(res.data.message);
        redirect('/contact');
      }
    }
  };
  return (
    <>
      <Header2 title="Contact Us" />
      <div className="container-fluid px-0 py-5 my-5">
        <div className="row mx-0 justify-content-center text-center">
          <div className="col-lg-6">
            <h6 className="d-inline-block bg-light text-primary text-uppercase py-1 px-2">
              Contact
            </h6>
            <h1>Contact Rajvi Cosmetic Clinic</h1>
          </div>
        </div>
        {/* Contact Start */}
        <div className="container-fluid py-5">
          <div className="container py-5">
            <div className="row">
              <div className="col-lg-6" style={{ minHeight: 500 }}>
                <div className="position-relative h-100">
                  <iframe
                    className="position-absolute w-100 h-100"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.4176600678416!2d72.67062987407564!3d23.045144615487782!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e875ee920e675%3A0x336ec467775198c5!2sRajvi%20Cosmetic%20Skin%20and%20Hair%20Clinic!5e0!3m2!1sen!2sin!4v1725713667805!5m2!1sen!2sin"
                    frameBorder={0}
                    style={{ border: 0 }}
                    allowFullScreen
                    aria-hidden="false"
                    tabIndex={0}
                  />
                </div>
              </div>
              <div className="col-lg-6 pt-5 pb-lg-5">
                <div className="contact-form bg-light p-4 p-lg-5 my-lg-5">
                  <h6 className="d-inline-block text-white text-uppercase bg-primary py-1 px-2">
                    Contact
                  </h6>
                  <h1 className="mb-4">Contact For Any Query</h1>

                  <form
                    name="sentMessage"
                    onSubmit={submithandle}>
                    <div className="form-row">
                      <div className="col-sm-6 control-group">
                        <input
                          type="text"
                          onChange={(e) => setname(e.target.value)}
                          name="name"
                          className="form-control border-0 p-4"
                          id="name"
                          placeholder="Your Name"
                        />
                        <p className="help-block text-danger" />
                      </div>
                      <div className="col-sm-6 control-group">
                        <input
                          type="email"
                          onChange={(e) => setemail(e.target.value)}
                          name="email"
                          className="form-control border-0 p-4"
                          id="email"
                          placeholder="Your Email"
                        />
                        <p className="help-block text-danger" />
                      </div>
                    </div>
                    <div className="control-group">
                      <input
                        type="number"
                        onChange={(e) => setmobile(e.target.value)}
                        name="mobile"
                        className="form-control border-0 p-4"
                        id="mobile"
                        placeholder="Mobile"
                      />
                      <p className="help-block text-danger" />
                    </div>
                    <div className="control-group">
                      <textarea
                        onChange={(e) => setcomment(e.target.value)}
                        name="comment"
                        className="form-control border-0 py-3 px-4"
                        rows={3}
                        id="message"
                        placeholder="Message"
                      />
                      <p className="help-block text-danger" />
                    </div>
                    <div>
                      <button
                        className="btn btn-primary py-3 px-4"
                        type="submit"
                        id="sendMessageButton"
                      >
                        Send Message
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Contact End */}
      <Footer />
      <Helmet>

        <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.bundle.min.js"></script>
        <script src="lib/easing/easing.min.js"></script>
        <script src="lib/waypoints/waypoints.min.js"></script>
        <script src="lib/counterup/counterup.min.js"></script>
        <script src="lib/owlcarousel/owl.carousel.min.js"></script>
        <script src="lib/tempusdominus/js/moment.min.js"></script>
        <script src="lib/tempusdominus/js/moment-timezone.min.js"></script>
        <script src="lib/tempusdominus/js/tempusdominus-bootstrap-4.min.js"></script>

        <script src="mail/jqBootstrapValidation.min.js"></script>
        <script src="mail/contact.js"></script>

        <script src="js/main.js"></script>
      </Helmet>
    </>
  );
}

export default Contact;
